import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const SearchIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootSearchIcon, className);

  // Using the green location pin icon instead of the search SVG
  return (
    <svg
      className={classes}
      width="18"
      height="22"
      viewBox="0 0 18 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0C4.029 0 0 4.029 0 9c0 6.763 9 13 9 13s9-6.237 9-13c0-4.971-4.029-9-9-9zm0 12a3 3 0 100-6 3 3 0 000 6z"
        fill="#8DD3A8" 
        fillRule="evenodd"
      />
    </svg>
  );
};

const { string } = PropTypes;

SearchIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

SearchIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default SearchIcon;
